import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=21d2844d&scoped=true&"
import script from "./Intro.vue?vue&type=script&lang=js&"
export * from "./Intro.vue?vue&type=script&lang=js&"
import style0 from "./Intro.vue?vue&type=style&index=0&id=21d2844d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d2844d",
  null
  
)

export default component.exports